import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__content form-custom" }
const _hoisted_2 = { class: "fill" }
const _hoisted_3 = { class: "mb-3 d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "bt-icon bt-icon--xs" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  key: 0,
  class: "h-100 d-flex justify-content-center align-items-center"
}
const _hoisted_8 = { class: "text-gray" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_10 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_11 = { class: "bt-icon bt-icon--sm" }
const _hoisted_12 = { class: "card__head d-flex flex-column w-100" }
const _hoisted_13 = { class: "ml-3 d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogEditBadge = _resolveComponent("DialogEditBadge")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("entrancePlant.associatedBadges")), 1),
          _createVNode(_component_Button, {
            disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
            onClick: _ctx.onShowAddBadgeDialog,
            class: "p-button-rounded p-button-outlined"
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_5, [
                _createVNode(_component_InlineSvgScoped, {
                  src: require(`@/assets/images/icons/icon-plus-outline.svg`)
                            ,
                  "aria-label": "icon-grid"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        (!_ctx.badges.length)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.BadgesListEmptyMessage")), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.badges, (badge) => {
          return (_openBlock(), _createBlock(_component_Card, {
            class: "apartment-card my-3 card--slim",
            key: badge
          }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require(`@/assets/images/entrancePlants/icon-badge.svg`)
                                    ,
                      "aria-label": "icon-badge"
                    }, null, 8, ["src"])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("span", null, _toDisplayString(badge), 1)
                  ])
                ]),
                _createVNode("button", {
                  disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
                  onClick: ($event: any) => (_ctx.onDeleteBadge(badge)),
                  class: "btn-stripped d-flex align-items-center text-danger"
                }, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                ], 8, ["disabled", "onClick"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _createVNode(_component_DialogEditBadge, {
      isVisible: _ctx.isVisibleDialogEditBadge,
      onHideDialog: _cache[1] || (_cache[1] = () => (_ctx.isVisibleDialogEditBadge = false)),
      onSaveBadge: _ctx.onSaveBadge
    }, null, 8, ["isVisible", "onSaveBadge"])
  ], 64))
}